// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"2b723d2f","348":"487eddd9","357":"7014e866","533":"2b723d2f","569":"2b723d2f","583":"7ee68e4b","789":"081eaafe","822":"2b723d2f"}[chunkId] + ".chunk.css";
};